<template>
  <div>
    <FormDialog
        :value="true"
        no-fullscreen
        :disabled="guardando"
        @close="$emit('close')"
        :toolbar-title="'Admitir Formulario #' + idFormulario"
        max-width="720px"
        @save="guardarForm()"
    >
      <template v-slot:form>
        <v-form @submit.prevent="guardarForm()">
        <RemoteGenericForm
            ref="remoteGenericForm"
            :base-url="baseUrl"
            :id="id"
            :campos-ignorados="camposIgnoradosComputed"
            :errores-validacion="erroresValidacion"
            :disabled="guardando || borrando || cargandoRegistro"
            v-model="formModel"
            :readonly="readOnly"
            @registroLoaded="onGetRegistroDto($event)"
            @cargandoRegistroChange="cargandoRegistro = $event"
            @dtoLoaded="onDtoLoaded($event)"
            :headers="headers"
            :field-with-hint-text="fieldWithHintText"
            :select-actions="selectActions"
            @appendEvent="appendEvent($event)"
        >
        </RemoteGenericForm>
        </v-form>
      </template>
    </FormDialog>
  </div>
</template>
<script>
import FormBase from '@/components/FormBase';
import FormDialog from '@/components/FormDialog';
import GenericForm from '@/components/generic-fields/GenericForm';

export default {
  name: "AdmitirFormularioForm",
  extends: FormBase,
  components: { GenericForm, FormDialog,},
  methods: {
    getFormModel () {
      let model =  Object.assign({}, this.formModel);
      model['idFormulario'] = this.idFormulario;
      return model;
    },
    onFormSaved() {
      this.$emit('saved');
    },
  },
  computed: {
    idFormulario() {
      return this.$route.params['id'];
    },
  },
}
</script>

<style scoped>

</style>
